<div class="not-found-container">
  <div class="content">
    <div class="error-code">404</div>
    <div class="circles">
      <div class="circle"></div>
      <div class="circle"></div>
      <div class="circle"></div>
    </div>
    <h1>Oops! Page Not Found</h1>
    <p>The page you're looking for doesn't exist or has been moved.</p>
    <a routerLink="/" class="back-home">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
        <polyline points="9 22 9 12 15 12 15 22"></polyline>
      </svg>
      Back to Home
    </a>
  </div>
</div>
